import api from "./axios";

export const getProducts = (params = {}, config = {}) =>
  api.get("/products", { ...config, params });
export const searchProducts = (query, limit = 50) =>
  api.get("/products/search", { params: { query, limit } });
export const getProductSuggestions = (field, query = "", limit = 30) =>
  api.get(`/products/suggestions/${field}`, { params: { query, limit } });
export const createProduct = (data) => api.post("/products", data);
export const updateProduct = (productPublicId, data) =>
  api.patch(`/products/${productPublicId}`, data);
export const deleteProduct = (productPublicId) =>
  api.delete(`/products/${productPublicId}`);

const variantBase = (productPublicId) =>
  `/products/${productPublicId}/variants`;
export const enableProductVariants = (productPublicId) =>
  api.post(`${variantBase(productPublicId)}/enable`);
export const getProductVariantConfiguration = (productPublicId, config = {}) =>
  api.get(variantBase(productPublicId), config);
export const createProductOption = (productPublicId, data) =>
  api.post(`${variantBase(productPublicId)}/options`, data);
export const updateProductOption = (productPublicId, optionPublicId, data) =>
  api.patch(`${variantBase(productPublicId)}/options/${optionPublicId}`, data);
export const deleteProductOption = (productPublicId, optionPublicId) =>
  api.delete(`${variantBase(productPublicId)}/options/${optionPublicId}`);
export const createProductOptionValue = (productPublicId, optionPublicId, data) =>
  api.post(`${variantBase(productPublicId)}/options/${optionPublicId}/values`, data);
export const updateProductOptionValue = (
  productPublicId,
  optionPublicId,
  valuePublicId,
  data,
) => api.patch(
  `${variantBase(productPublicId)}/options/${optionPublicId}/values/${valuePublicId}`,
  data,
);
export const deleteProductOptionValue = (
  productPublicId,
  optionPublicId,
  valuePublicId,
) => api.delete(
  `${variantBase(productPublicId)}/options/${optionPublicId}/values/${valuePublicId}`,
);
export const createProductVariant = (productPublicId, data) =>
  api.post(variantBase(productPublicId), data);
export const updateProductVariant = (productPublicId, variantPublicId, data) =>
  api.patch(`${variantBase(productPublicId)}/${variantPublicId}`, data);

export const getProductBarcodes = (productPublicId) =>
  api.get(`/products/${productPublicId}/barcodes`);
export const createProductBarcode = (productPublicId, data) =>
  api.post(`/products/${productPublicId}/barcodes`, data);
export const setPrimaryProductBarcode = (productPublicId, barcodePublicId) =>
  api.put(`/products/${productPublicId}/barcodes/${barcodePublicId}/primary`);
export const deleteProductBarcode = (productPublicId, barcodePublicId) =>
  api.delete(`/products/${productPublicId}/barcodes/${barcodePublicId}`);

export const getProductImagePolicy = () =>
  api.get("/products/media/image-policy");
export const getProductImage = (productPublicId, config = {}) =>
  api.get(`/products/${productPublicId}/image`, {
    ...config,
    responseType: "blob",
  });
export const uploadProductImage = (productPublicId, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.put(`/products/${productPublicId}/image`, form);
};
export const deleteProductImage = (productPublicId) =>
  api.delete(`/products/${productPublicId}/image`);

export const getProductVariantImage = (productPublicId, variantPublicId, config = {}) =>
  api.get(`/products/${productPublicId}/variants/${variantPublicId}/image`, {
    ...config,
    responseType: "blob",
  });
export const uploadProductVariantImage = (productPublicId, variantPublicId, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.put(`/products/${productPublicId}/variants/${variantPublicId}/image`, form);
};
export const deleteProductVariantImage = (productPublicId, variantPublicId) =>
  api.delete(`/products/${productPublicId}/variants/${variantPublicId}/image`);
